import { render, staticRenderFns } from "./Expertise.vue?vue&type=template&id=e4008a58&scoped=true&"
import script from "./Expertise.vue?vue&type=script&lang=js&"
export * from "./Expertise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4008a58",
  null
  
)

export default component.exports